import { Footer } from "@/components/layout/footer";
import { SectionVerticalSlide } from "@/components/sectionVerticalSlide";
import { useGetBaseInfo, useGetCommon, type BaseInfoResponse, type MainInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { AboutSection, RoomPreview, SpecialPreview, TopSection, Travel } from "../common";
import { CTASection } from "../common/components/ctaSection";

export const Home = () => {
    const { data: footerData } = useGetBaseInfo<BaseInfoResponse>();
    const { data } = useGetCommon<MainInfoResponse>({ section: "main" });

    return data && footerData ? (
        <SectionVerticalSlide>
            <TopSection imgList={data.imgList} catchPraise={data.catchPraise} />
            <AboutSection />
            <RoomPreview />
            <SpecialPreview />
            <CTASection imgList={data.imgList} />
            <Travel />
            <Footer
                isPrivate={footerData.isPrivate}
                logoUrl={footerData.logoUrl}
                pensionInfo={footerData.pensionInfo}
                ybs={footerData.ybs}
                yeogi={footerData.yeogi}
            />
        </SectionVerticalSlide>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
